<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        :title="`Uitbreiding toevoegen aan ${payloadData.serviceData.data.name} dienst`"
        :icon="plusIcon"
        :large="true"
    >
      <dean-load-overlay
          v-if="loading"
      ></dean-load-overlay>
      <dean-notification :is-modal="true">

      </dean-notification>

      <perfect-scrollbar
          :options="{suppressScrollX:true}"
          class="small-12 medium-12 large-12 hd-12 columns">
        <dean-select-form-row id="product" label="Product" v-model="selectedProduct" :required-field="true"
                              placeholder="Kies een product" :options="data"
                              :warning="$v.selectedProduct.$invalid"
                              clearable/>
        <dean-form-row
            :label="`Aantal (Maximaal ${rules[selectedProduct.value]['limit']})`"
            required="true"
            type="number"
            :max="rules[selectedProduct.value]['limit']"
            :disabled="rules[selectedProduct.value]['limit'] === 1"
            :min="1"
            id="quantity"
            v-model="quantity"
            required-field="true"
            v-if="selectedProduct"
            text/>
        <collapse-transition>
          <div v-show="selectedProduct">
            <div>
              <h4>Prijs</h4>
              <div class="form-row" v-if="selectedProduct">
                <div class="label">Aansluitprijs</div>
                <div class="value">
                  {{
                    new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format((rules[selectedProduct.value]['chargeConnectPriceOnce'] ? 1 : quantity) * prices[selectedProduct.value].connectPrice)
                  }}
                </div>
              </div>
              <div class="form-row" v-if="selectedProduct">
                <div class="label">Maandelijks</div>
                <div class="value" v-if="quantity * prices[selectedProduct.value].recurringPrice % 1 === 0">
                  {{
                    new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(quantity * prices[selectedProduct.value].recurringPrice)
                  }}
                </div>
                <div class="value" v-else>
                  {{
                    new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(quantity * prices[selectedProduct.value].recurringPrice)
                  }}
                </div>
              </div>
            </div>
          </div>
        </collapse-transition>
        <b-table ref="extraProducts" id="second-table" :items="additionalData"
                 :fields="fields"
                 v-if="selectedProduct">
          <template v-slot:cell()="data">
            <div v-if="getField(data.field.key).type === ProductType.DATE">
              <wish-date :label="buttonLabel(getField(data.field.key).name)"
                         v-model="additionalData[data.index][getField(data.field.key).name]"></wish-date>
            </div>

            <div v-if="getField(data.field.key).type === ProductType.PHONE_NUMBER">
              <dean-input-field
                  type="text"
                  v-model="additionalData[data.index][getField(data.field.key).name]"
                  :label="buttonLabel(getField(data.field.key).name)"
                  :disabled="true"
              >
                <slot>{{ buttonLabel(getField(data.field.key).name) }}</slot>
              </dean-input-field>
            </div>

            <div v-if="getField(data.field.key).type === ProductType.BOOLEAN || getField(data.field.key).type === ProductType.CONTRACTED_SERVICE">
              <dean-input-switch @checked="toggleSwitch(getField(data.field.key).name);"
                                 :checked="additionalData[data.index][getField(data.field.key).name]"
                                 :label="buttonLabel(getField(data.field.key).name)"
              ></dean-input-switch>
            </div>

            <div v-if="getField(data.field.key).type === ProductType.STRING">
              <dean-input-field
                  type="text"
                  v-model="additionalData[data.index][getField(data.field.key).name]"
                  :label="buttonLabel(getField(data.field.key).name)"
                  :disabled="getField(data.field.key).condition && !additionalDataFields[getField(data.field.key).condition]"
              >
                <slot>{{ buttonLabel(getField(data.field.key).name) }}</slot>
              </dean-input-field>
            </div>

            <div v-if="getField(data.field.key).type === ProductType.SIM_NUMBER">
              <sim-number-search
                  :partnerCode="partnerCode"
                  :customerId="customerId"
                  :value="data.value"
                  :searchType="getField(data.field.key).simType"
                  :searchProvider="getField(data.field.key)?.simProvider ?? getDefaultSimType()"
                  @simNumberSelected="setSimNumber($event, data.field.name, data.index)">
              </sim-number-search>
            </div>
            <div v-if="getField(data.field.key).type === ProductType.ADDRESS">
              <dean-select-form-row
                  id="address" placeholder="kies een adres" key="address"
                  :required-field="true" :hide-label="true"
                  :options="addresses"
                  @input="valueChanged($event, data.index, data.field.key)"
                  :clearable="true">
              </dean-select-form-row>
            </div>
          </template>
        </b-table>
      </perfect-scrollbar>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Sluiten</dean-button>
        <dean-button :success="true" :dialog-button="true"
                     @click.native="processOrder">Bestellen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import SimNumberSearch from '@/components/quote/simNumberSearch.vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
import {
  // SVG
  warningIcon,
  // COMPONENTS
  deanDialog,
  plusIcon,
  orderIcon,
  deanTable,
  deanLoadOverlay,
} from '@deanone/dean-components';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import DeanFormRow from '@/components/deanComponents/deanFormRow.vue';
import DeanInputField from '@/components/deanComponents/deanInputField.vue';
import deanAccordion from '@/components/deanComponents/deanAccordion.vue';
import DeanInputSwitch from '@/components/deanComponents/deanInputSwitch.vue';
import WishDate from '@/components/quote/wishDate.vue';
import {BTable} from 'bootstrap-vue';
import {deanDialogBus} from '@/main';
import {CollapseTransition} from 'vue2-transitions';
import {required, requiredIf} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import axios from 'axios';
import {getErrorMessageFromResponse} from '@/mixins/errorMessage';
import {ProductType} from "@/enums/ProductType";
import {getDefaultSimType} from "@/enums/SimProvider";
import {getButtonLabel} from "@/mixins/buttonTranslation";

@Component({
  methods: {getDefaultSimType},
  computed: {
    ProductType() {
      return ProductType
    }
  },
  components: {
    DeanInputField,
    DeanFormRow,
    deanLoadOverlay,
    deanAccordion,
    warningIcon,
    DeanNotification,
    DeanSelectFormRow,
    deanDialog,
    deanButton,
    DeanInputSwitch,
    orderIcon,
    CollapseTransition,
    deanTable,
    BTable,
    WishDate,
    SimNumberSearch,
  },
})

export default class ServiceAddAdditionalProduct extends Vue {
  // DATA
  @Prop() public payloadData!: {
    [key: string]: any,
  };
  public data: any = [];
  public rules: any = [];
  public prices: any = {};
  public fields: any = [];
  public addresses: any = [];
  public additionalDataFields: any = {};
  public additionalData: any = [];
  public plusIcon: any = plusIcon;
  public loading: boolean = false;
  public selectedProduct: any = null;
  public quantity: number = 1;
  public additionalDataValidations = {};
  public partnerCode: string = '';
  public customerId: string = '';

  // COMPUTED
  @Validations()
  get validations() { // TODO
    return {
      selectedProduct: {
        required,
      },
      quantity: {
        required,
      },
      additionalData: {
        $each: this.additionalDataValidations,
      },
    };
  }

  get condition() {
    return (condition: string | number) => {
      return this.additionalDataFields[condition] === true;
    };
  }

  public toggleSwitch(fieldName: string) {
    Vue.set(this.additionalDataFields, fieldName, !this.additionalDataFields[fieldName]);
  }

  @Watch('selectedProduct')
  public checkFields() {
    const fieldsKey = 'fields';
    this.fields = [];
    this.additionalDataFields = {};
    this.additionalData = [];

    if (!this.selectedProduct) {
      return;
    }

    this.quantity = 1;

    if (!('fields' in this.rules[this.selectedProduct.value])) {
      return;
    }

    for (const field of this.rules[this.selectedProduct.value][fieldsKey]) {
      this.fields.push({
        label: getButtonLabel(field.name),
        key: field.name,
        sortable: false,
        ...field,
      });
      let initialValue = null;
      switch (field.type) {
        case 'BOOLEAN':
          initialValue = false;
          break;

        case 'DATE':
          const today = new Date();
          initialValue = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()}`;
          break;

        default:
          initialValue = null;
          break;
      }

      Vue.set(this.additionalDataFields, field.name, initialValue);
      Vue.set(this.additionalDataValidations, field.name, field.condition ? {
        required: requiredIf(
            () => {
              return this.additionalDataFields[field.condition];
            },
        ),
      } : {required});
    }

    for (let i = 0; i < this.quantity; i++) {
      Vue.set(this.additionalData, i, {...this.additionalDataFields});
    }
  }


  @Watch('quantity')
  public checkQuantity() {
    if (!this.selectedProduct) {
      return;
    }

    if (!('fields' in this.rules[this.selectedProduct.value])) {
      return;
    }

    // Pop items off if data list is bigger than quantity
    // Add items if data list is smaller than quantity
    if (this.additionalData.length > this.quantity) {
      this.additionalData = this.additionalData.slice(0, this.quantity);
    } else if (this.additionalData.length < this.quantity) {
      while (this.additionalData.length < this.quantity) {
        this.additionalData.push({...this.additionalDataFields});
      }
    }
    // this.additionalData = this.additionalData.slice();
  }

  // METHODS
  public close() {
    deanDialogBus.$emit('close');
  }

  public setSimNumber(newSimNumber: any, fieldName: any, index: any) {
    if ('simNumber' === fieldName) {
      this.additionalData[index].tmlCopyNumber = newSimNumber.tmlNumber;
      this.additionalData[index].simNumber = newSimNumber.simNumber;
    } else if ('simNumber2' === fieldName) {
      this.additionalData[index].tmlCopyNumber2 = newSimNumber.tmlNumber;
      this.additionalData[index].simNumber2 = newSimNumber.simNumber;
    }
  }

  public getField(fieldName: string) {
    return this.fields.filter((field: any) => field.name === fieldName)[0];
  }

  public buttonLabel(fieldName: string): string {
    return getButtonLabel(fieldName);
  }

  public processOrder() {
    this.loading = true;
    this.$v.$touch();

    if (!this.$v.$invalid) {
      axios.post('/-/trade/api/customer.service.additionalProduct.order', {
        serviceId: this.payloadData.serviceData.data.id,
        customerId: this.customerId,
        product: this.selectedProduct.value,
        quantity: this.quantity,
        additionalData: this.fields.length ? this.additionalData : undefined,
      }).then(
          (response) => {
            this.$toast({
              icon: orderIcon,
              title: 'Order aangemaakt',
              text: 'Uw order is aangemaakt.',
              theme: 'success',
            });

            this.$router.push({name: 'customers.orders.list', params: {
              pid: this.$route.params.pid,
            }});

            deanDialogBus.$emit('close');
          },
          (error) => {
            const errorResponse = error.response.data;

            const errorMessage: string|null = getErrorMessageFromResponse(errorResponse);

            if (errorMessage) {
              this.$toast({
                icon: warningIcon,
                title: 'Waarschuwing',
                text: errorMessage,
                theme: 'warning',
              });
            } else {
              this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
            }
          },
      ).finally(
          () => {
            this.loading = false;
          },
      );
    } else {
      this.$toast({
        icon: warningIcon,
        title: 'Waarschuwing',
        text: 'Onjuist verzoek. Zorg ervoor dat alle velden zijn ingevuld en probeer het nogmaals.',
        theme: 'warning',
      });
      this.loading = false;
    }
  }

  public created() {
    this.loading = true;
    this.customerId = this.$route.params.pid;

    axios.post('/-/trade/api/customer.service.additionalProducts.info', {
      serviceId: this.payloadData.serviceData.data.id,
      customerId: this.customerId,
    }).then(
        (response) => {
          if (!response.data.additionalProducts.length) {
            this.$toast({
              icon: warningIcon,
              title: 'Waarschuwing',
              text: 'Geen uitbreidingen gevonden voor het gekozen product.',
              theme: 'warning',
            });
            deanDialogBus.$emit('close');
          } else {
            this.data = response.data.additionalProducts.map((product: any) => {
              return {
                label: product.product.publicName,
                value: product.product.id,
              };
            });
          }

          this.rules = response.data.rules;
          response.data.additionalProducts.forEach((product: any) => {
            this.prices[product.product.id] = {
              connectPrice: product.price.connectPrice,
              recurringPrice: product.price.recurringPrice,
            };
          });

          this.partnerCode = response.data.partnerCode;

          this.addresses = response.data.addresses.map((address: any) => {
            return {
              label: address.label,
              value: address.id,
            };
          });
        },

        (error) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
    ).finally(
        () => {
          this.loading = false;
        },
    );
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>

// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

.list-enter-active, .list-leave-active {
  transition: all 1s;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
}

.form-row {
  display: flex;

  div {
    flex-grow: 1;
    width: 50%;

    &.label {
      padding: 10px 10px 10px 25px;
    }

    &.value {
      padding: 10px 10px 10px 0;
    }
  }
}

.field {
  display: flex;
  align-items: center;

  .label {
    padding-left: 10px;
    flex-grow: 1;
    width: 50%;
  }

  .value {
    flex-grow: 1;
    width: 50%;
  }
}

.dean-table table td {
  height: auto !important;
}

</style>

<style lang="scss">

.vs__dropdown-menu {
  width: auto !important;
}

.v-select__selections input {
  display: none
}

.dean-dialog-slot {
  overflow-y: auto;
}

</style>
